<template>
  <v-container fluid pa-0>
    <!-- <containerGlobo/> -->
    <Slider/>
    <HomeInfo/>
  </v-container>
</template>

<script>
import Slider from './Home/Slider'
import HomeInfo from './Home/HomeInfo'
// import containerGlobo from './Home/Globo'
  import * as firebase from 'firebase/app'
  import 'firebase/firestore'
export default {
  title: 'Transportes DUO',
  name: 'App',
  components: {
    Slider,
    HomeInfo,
    // containerGlobo
  },
  data () {
    return {
      //
    }
  }
}
</script>